import { render, staticRenderFns } from "./douyin_aweme_comment.vue?vue&type=template&id=165d794b"
import script from "./douyin_aweme_comment.vue?vue&type=script&lang=js"
export * from "./douyin_aweme_comment.vue?vue&type=script&lang=js"
import style0 from "./douyin_aweme_comment.vue?vue&type=style&index=0&id=165d794b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports